import { useEffect, useState } from "react";
import ERPAnalyticsHeader from "../components/ERPAnalyticsHeader";
import { api } from "../lib/api";

export default function AuditLogs() {
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    api.get("/audit-logs?limit=200").then((r) => setLogs(r.data.logs || []));
  }, []);

  return (
    <div className="erp-home-shell">
      <ERPAnalyticsHeader />

      <main className="erp-content">
        <div className="erp-page-title-row">
          <div>
            <h1>Audit Logs</h1>
            <p>Recent platform actions within this workspace.</p>
          </div>
        </div>

        <div className="erp-card">
          <table className="tbl" data-testid="audit-table">
            <thead>
              <tr>
                <th>Time</th>
                <th>User</th>
                <th>Action</th>
                <th>Resource</th>
                <th>Detail</th>
              </tr>
            </thead>

            <tbody>
              {logs.map((l) => (
                <tr key={l.id}>
                  <td className="font-mono text-[12px]">
                    {new Date(l.created_at).toLocaleString()}
                  </td>
                  <td>{l.user_email || "—"}</td>
                  <td><span className="pill">{l.action}</span></td>
                  <td className="font-mono text-[12px]">
                    {l.resource_type || "—"} {l.resource_id ? `· ${l.resource_id.slice(0, 14)}` : ""}
                  </td>
                  <td className="text-[11.5px]" style={{ color: "var(--c-text-muted)" }}>
                    {l.detail ? JSON.stringify(l.detail) : ""}
                  </td>
                </tr>
              ))}

              {logs.length === 0 && (
                <tr>
                  <td colSpan={5} className="text-center py-6" style={{ color: "var(--c-text-muted)" }}>
                    No audit events.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </main>
    </div>
  );
}
